import React from 'react';

import { ProgramReviewReport } from 'components';

export const ProgramReviewReportPage = () => {
    return <ProgramReviewReport />;
};
